import { Component, computed, input, model, output } from '@angular/core';
import { MobileNumberDto } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '../../../edit-wrapper/form-edit-wrapper.component';
import { AuraContactInfosPhoneComponent } from '../display/contact-infos-phone-display.component';
import { AuraContactInfosFormComponent } from '../form/contact-infos-phone-form.component';

@Component({
  selector: 'aura-contact-infos-phone-edit',
  imports: [AuraContactInfosFormComponent, AuraEditWrapperComponent, AuraContactInfosPhoneComponent],
  templateUrl: './contact-infos-phone-edit.component.html',
})
export class AuraContactInfosPhoneEditComponent {
  initialMobileNumber = input.required<string>();
  isEditing = model<boolean>(false);
  isAllowedToEdit = input<boolean>(false);

  phoneNumberSaved = output<MobileNumberDto>();

  currentMobileNumber = computed<MobileNumberDto | null>(() => {
    const mobileNumber = this.initialMobileNumber();
    return mobileNumber ? { mobileNumber } : null;
  });
}
